// extracted by mini-css-extract-plugin
export default {"PaymentMethodDropdown__Optional":"PaymentMethodDropdown__PaymentMethodDropdown__Optional__So_hq"};